import { PositionClasses_Position_$ctor_Z207A3CFB, PositionClasses_BreakInside_$ctor_Z207A3CFB, PositionClasses_Break_$ctor_Z207A3CFB, WritingModeClasses_WritingMode_$ctor_Z207A3CFB, PositionClasses_Direction_$ctor_Z207A3CFB, PositionClasses_BoxSizing_$ctor_Z207A3CFB, PositionClasses_Float_$ctor_Z207A3CFB, PositionClasses_VerticalAlign_$ctor_Z207A3CFB, PositionClasses_TopRightBottomLeft_$ctor_Z207A3CFB } from "../Types/Position.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const Top = PositionClasses_TopRightBottomLeft_$ctor_Z207A3CFB(new Property_CssProperty(283));

export const Right = PositionClasses_TopRightBottomLeft_$ctor_Z207A3CFB(new Property_CssProperty(232));

export const Bottom = PositionClasses_TopRightBottomLeft_$ctor_Z207A3CFB(new Property_CssProperty(60));

export const Left = PositionClasses_TopRightBottomLeft_$ctor_Z207A3CFB(new Property_CssProperty(151));

export const VerticalAlign = PositionClasses_VerticalAlign_$ctor_Z207A3CFB(new Property_CssProperty(295));

export const Float = PositionClasses_Float_$ctor_Z207A3CFB(new Property_CssProperty(106));

export const BoxSizing = PositionClasses_BoxSizing_$ctor_Z207A3CFB(new Property_CssProperty(63));

export const Direction = PositionClasses_Direction_$ctor_Z207A3CFB(new Property_CssProperty(92));

export const WritingMode = WritingModeClasses_WritingMode_$ctor_Z207A3CFB(new Property_CssProperty(313));

export const BreakAfter = PositionClasses_Break_$ctor_Z207A3CFB(new Property_CssProperty(64));

export const BreakBefore = PositionClasses_Break_$ctor_Z207A3CFB(new Property_CssProperty(65));

export const BreakInside = PositionClasses_BreakInside_$ctor_Z207A3CFB(new Property_CssProperty(66));

export const Position = PositionClasses_Position_$ctor_Z207A3CFB(new Property_CssProperty(225));

